// Brutalist minimal dark system
export const theme = {
  colors: {
    background: {
      canvas: "#000000",
      primary: "#0a0a0a",
      secondary: "#141414",
      tertiary: "#1a1a1a",
      quaternary: "#202020",
      muted: "#2a2a2a",
      overlay: "rgba(0, 0, 0, 0.9)",
    },
    stroke: {
      faint: "#1a1a1a",
      subtle: "#2a2a2a",
      strong: "#404040",
      accent: "#ffffff",
    },
    accent: {
      primary: "#ffffff",
      secondary: "#e5e5e5",
      tertiary: "#d4d4d4",
      success: "#22c55e",
      warning: "#eab308",
      danger: "#ef4444",
      neutral: "#737373",
    },
    text: {
      primary: "#ffffff",
      secondary: "#a3a3a3",
      muted: "#737373",
      disabled: "#525252",
    },
    status: {
      success: "#22c55e",
      warning: "#eab308",
      error: "#ef4444",
      info: "#3b82f6",
      neutral: "#737373",
    },
  },
  
  typography: {
    fontFamily: {
      primary:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      base: "0.9375rem",
      lg: "1rem",
      xl: "1.125rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.5rem",
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 900,
    },
  },
  
  spacing: {
    "2xs": "0.25rem",
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
  },
  
  borderRadius: {
    xs: "0",
    sm: "0",
    md: "2px",
    lg: "4px",
    xl: "6px",
    "2xl": "8px",
    pill: "999px",
    full: "9999px",
  },
  
  shadows: {
    card: "none",
    cardHover: "0 0 0 1px #ffffff",
    pop: "none",
    glow: "0 0 0 2px #ffffff",
  },

  borders: {
    base: "1px solid #2a2a2a",
    strong: "1px solid #404040",
  },
  
  transitions: {
    fast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
    normal: "250ms cubic-bezier(0.4, 0, 0.2, 1)",
    slow: "350ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
    wide: "1280px",
  },
};


